import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiRequest } from "../../Api/Api";
import { ENDPOINTS } from "../../Api/Endpoints";

/** Maps `/request/:id/bidding` → care pricing / bid UI (uses match request in session). */
export default function RequestBiddingRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!id) {
        navigate("/HealBidDashboard", { replace: true });
        return;
      }
      try {
        const res = await apiRequest({
          method: "GET",
          url: ENDPOINTS.GET_MATCH_REQUEST_DETAIL(String(id)),
        });
        const row = res?.request || null;
        const w = String(row?.requestWorkflowStatus || "").toUpperCase();
        if (w === "PENDING_ADMIN_REVIEW" || w === "REJECTED") {
          if (!cancelled) {
            navigate(`/patient-match-request/${encodeURIComponent(String(id))}`, {
              replace: true,
              state: { requestRow: row || { matchRequestId: id, requestWorkflowStatus: w } },
            });
          }
          return;
        }
        if (!["BIDDING", "BID_SELECTED", "BOOKED", "VISIT_COMPLETED", "VERIFIED"].includes(w)) {
          if (!cancelled) {
            navigate(`/patient-match-request/${encodeURIComponent(String(id))}`, {
              replace: true,
              state: { requestRow: row || { matchRequestId: id } },
            });
          }
          return;
        }
      } catch {
        if (!cancelled) {
          navigate("/HealBidDashboard", { replace: true });
        }
        return;
      }
      if (cancelled) return;
      try {
        window.localStorage.setItem("healbid:careprice:lastMatchRequestId", id);
      } catch (_) {}
      navigate("/care-price", { replace: true, state: { matchRequestId: id } });
    })();
    return () => {
      cancelled = true;
    };
  }, [id, navigate]);

  return null;
}
